import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';

const EmployeeWorkTimeDetails = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
  
  let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(440)); 
        console.log(permission);

  
       axios.get(`/employee-work-time-tracking-details/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
       
        setData(response.data.data.employee_tracking);
        setValue(response.data.data.employee);
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



// ✅ Define EditCell before using it
const EditCell = ({ row, permission }) => {
  if (permission && permission.update == 1) {
    return (
      <div>
        <button
          className="btn btn-primary btn-block"
          id={`button-all-${row.original.id}`}
          onClick={() => updateTracking(row.original.id)}
        >
          Update
        </button>
      </div>
    );
  }
  return null;
};

// ✅ Explicitly define PropTypes for EditCell
EditCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
  permission: PropTypes.shape({
    update: PropTypes.number,
  }),
};

// ✅ Define EditCellWrapper after EditCell
const EditCellWrapper = ({ row }) => <EditCell row={row} permission={permission} />;

// ✅ Explicitly define PropTypes for EditCellWrapper
EditCellWrapper.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Now, define the `columns` array after all functions are declared



  const DownloadSlip = async (row) => {
      let season_id = localStorage.getItem("season_id");
 Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/employee-work-time-tracking-delete/${season_id+'-'+row.id}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );

                 axios.get(`/employee-work-time-tracking-details/${season_id+'-'+id}`, {
                    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                  })
                  .then((response) => {
                  
                    setData(response.data.data.employee_tracking);
                    setValue(response.data.data.employee);
                  
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                // setTimeout(() => {
                //   window.location.href = "/work-time-tracking-view-all/"+id;
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
    //   let season_id = localStorage.getItem("season_id");

    // $("#loader-image2").removeClass('loader-hide2');
    // $("#loader-image2").addClass('loader-show2');
    // window.open(`${base_url}/employee-work-time-tracking-delete/${season_id+'-'+row.id}`, '_blank');
    // $("#loader-image2").addClass('loader-hide2');
    // $("#loader-image2").removeClass('loader-show2');
  }
const ActionColumnDownload = ({ row }) => {
  return (
    <div>
      <button
        className="btn btn-danger btn-block"
        id={`button-all-${row.original.id}`}
        onClick={() => DownloadSlip(row.original)}
      >
        Delete
        
      </button>
    </div>
  );
};

// ✅ Define PropTypes for ActionColumn
ActionColumnDownload.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Define ActionCell as a separate component
const DownloadSituation = ({ row }) => <ActionColumnDownload row={row} />;

// ✅ Define PropTypes for ActionCell
DownloadSituation.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

const columns = [
  //{ accessorKey: 'date', header: 'Date' },
    {
  accessorKey: 'date',
  header: 'Date',
  accessorFn: (row) => {
    if (!row.date) return '';
    const date = new Date(row.date);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  },
},
  { accessorKey: 'start_time_1', header: 'Start Time 1' },
  { accessorKey: 'end_time_1', header: 'End Time 1' },
  { accessorKey: 'start_time_2', header: 'Start Time 2' },
  { accessorKey: 'end_time_2', header: 'End Time 2' },
  { accessorKey: 'shift_hours', header: 'Shift Hours' },
  { accessorKey: 'shift', header: 'Shift' },
  { accessorKey: 'advanced_on_salary', header: 'Advance On Salary' },
  { accessorKey: 'holiday_shift', header: 'Holiday Shift' },
  { header: 'EDIT', Cell: EditCellWrapper }, // ✅ Assigning function directly (No inline)
   {
    header: 'Delete',
    Cell: DownloadSituation, // ✅ Pass the validated component directly
  },

];

  
const updateTracking = async (tracking_id) => {
  try {

    console.log("season_id");
    console.log(season_id);
    const response = await axios.get(`/employee-work-time-tracking-edit/${season_id+'-'+tracking_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    });
    
    const tracking = response.data.data.tracking;
    const holiday_check = tracking.holiday_shift ? 'checked' : '';
    const employee_name = `${tracking.emp_name.first_name} ${tracking.emp_name.last_name}`;


    const { value: formValues } = await Swal.fire({
      // title: 'Employee Work Time Tracking',
       title: `${employee_name}<br>Employee Work Time Tracking`,
      html: `
        <div style="display: grid;">
          <input type="hidden" id="tracking_id" value="${tracking.id}">
             <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Date</label> 
          <input  style="margin: 0em 0em 1em 0em !important;" type="date" id="datePicker" class="swal2-input" value="${tracking.date}">
          <div style="width:100%;">	
          	<div style="width:50%;float:left">
             <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> Start time 1</label> 
             		   <input type="time" style="width:100%; margin: 0em 0em 1em 0em !important;" id="start_time_1" class="swal2-input" placeholder="Start Time" value="${tracking.start_time_1}">
            </div>	
          <div style="width:50%;float:left;">
          <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> End Time 1</label>
           <input type="time" style="width:100%; margin: 0em 0em 1em 0em !important;" id="end_time_1" class="swal2-input" placeholder="End Time" value="${tracking.end_time_1}">
           </div>
          </div> 
              <div style="width:100%;">		
              <div style="width:50%;float:left">
               <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> Start time 2</label> 
               		   <input type="time" style="width:100%; margin: 0em 0em 1em 0em !important;" id="start_time_2" class="swal2-input" placeholder="Start Time" value="${tracking.start_time_2}">
                </div>
              <div style="width:50%;float:left;">
              <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> End Time 2</label>
               <input type="time" style="width:100%; margin: 0em 0em 1em 0em !important;" id="end_time_2" class="swal2-input" placeholder="End Time" value="${tracking.end_time_2}">
               </div> 
          </div>  
          <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Shift Hours</label>
          <input type="number"  style="margin: 0em 0em 1em 0em !important;" id="shift_hours" class="swal2-input" placeholder="Enter Shift Hours" value="${tracking.shift_hours}">
          <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Shift</label>
          <input type="number"  style="margin: 0em 0em 1em 0em !important;" id="shift" class="swal2-input" placeholder="Enter Shift" value="${tracking.shift}">
          <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Advance On Salary</label> 
          <input type="number" style="margin: 0em 0em 1em 0em !important;" id="advanced_on_salary" class="swal2-input" placeholder="Advance On Salary" value="${tracking.advanced_on_salary}">
          <div style="text-align: left;; margin-top: -20px;">
            Holiday shift<input type="checkbox"  value="1" id="holiday_shift" class="swal2-input" style="margin: 0; position: relative; top: 20px; left: 12px;" ${holiday_check}>
          </div>
        </div>
      `,
          didOpen: () => {
        const calculateShiftHours = () => {
          const start_time_1 = document.getElementById('start_time_1').value;
          const end_time_1 = document.getElementById('end_time_1').value;
          const start_time_2 = document.getElementById('start_time_2').value;
          const end_time_2 = document.getElementById('end_time_2').value;

          const timeToMinutes = (time) => {
            if (!time) return null;
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
          };

          const getHoursDiff = (startMinutes, endMinutes) => {
            let diff = endMinutes - startMinutes;
            if (diff < 0) diff += 24 * 60; // crosses midnight
            return diff / 60;
          };

          let totalShiftHours = 0;

          if (start_time_1 && end_time_1) {
            const startMins = timeToMinutes(start_time_1);
            const endMins = timeToMinutes(end_time_1);
            totalShiftHours += getHoursDiff(startMins, endMins);
          }

          if (start_time_2 && end_time_2) {
            const startMins = timeToMinutes(start_time_2);
            const endMins = timeToMinutes(end_time_2);
            totalShiftHours += getHoursDiff(startMins, endMins);
          }

          document.getElementById('shift_hours').value = totalShiftHours.toFixed(2);
        };

        document.getElementById('start_time_1').addEventListener('input', calculateShiftHours);
        document.getElementById('end_time_1').addEventListener('input', calculateShiftHours);
        document.getElementById('start_time_2').addEventListener('input', calculateShiftHours);
        document.getElementById('end_time_2').addEventListener('input', calculateShiftHours);
      },

      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        const tracking_id = document.getElementById('tracking_id').value;
        const date = document.getElementById('datePicker').value;
        const shift = document.getElementById('shift').value;
        const shift_hours = document.getElementById('shift_hours').value;
        //const extra_hours = document.getElementById('extra_hours').value;
        const holiday_shift = document.getElementById('holiday_shift').checked ? 1 : 0;
        const advanced_on_salary = document.getElementById('advanced_on_salary').value;
        const start_time_1 = document.getElementById('start_time_1').value;
        const start_time_2 = document.getElementById('start_time_2').value;
        const end_time_1 = document.getElementById('end_time_1').value;
        const end_time_2 = document.getElementById('end_time_2').value;
     
        if (!date) {
          Swal.showValidationMessage('Date is required');
          return null;
        }
        if (!shift_hours) {
          Swal.showValidationMessage('Shift Hours is required');
          return null;
        }
        // if (!extra_hours) {
        //   Swal.showValidationMessage('Extra Hours is required');
        //   return null;
        // }
        if (!advanced_on_salary) {
          Swal.showValidationMessage('Advance On Salary is required');
          return null;
        }
        return { tracking_id, date, shift_hours,shift, holiday_shift, advanced_on_salary, start_time_1, start_time_2, end_time_1, end_time_2 };
      }
    });

    if (formValues) {
      try {
        const updateResponse = await axios.post(`/employee-work-time-tracking-update`, {
          id: formValues.tracking_id,
          season_id: season_id,            
          date: formValues.date,
          shift_hours: formValues.shift_hours,
          shift: formValues.shift,
          //extra_hours: formValues.extra_hours,
          holiday_shift: formValues.holiday_shift,
          advanced_on_salary: formValues.advanced_on_salary,
          start_time_1: formValues.start_time_1,
          start_time_2: formValues.start_time_2,
          end_time_1: formValues.end_time_1,
          end_time_2: formValues.end_time_2
        }, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken
          },
        });

        if (updateResponse.data.code === 200) {
          axios.get(`/employee-work-time-tracking-details/${season_id+'-'+id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
           
            setData(response.data.data.employee_tracking);
            setValue(response.data.data.employee);
           
          })
          .catch((error) => {
            console.log(error);
          });
          Swal.fire(
            'Success!',
            'Employee Work Time Tracking updated Successfully.',
            'success'
          );
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'There was a problem updating Employee Work Time Tracking.',
          'error'
        );
      }
    }
  } catch (error) {
    console.error(error);
  }
};

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
      {permission && permission.list == 1 && ( 

        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Employees Work Time Tracking Details</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Employees Work Time Tracking Details</li>
                </ul>
              </div>
            
            </div>
          </div>

          <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Employee Information</h4>
                    <table className="table table-bordered">
                    <tr>
                        <th className="p-3">
                          {/* Profile Image */}
                          </th>
                        <td className="p-3">
                        {/* <img
                                className="avatar-img"
                                src={user_iamge}
                                alt="Profile Image"
                                width={200}
                                height={200}
                              /> */}
                          </td>
                      </tr>
                    <tr>
                        <th className="p-3">First Name</th>
                        <td className="p-3">{value.first_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Last Name</th>
                        <td className="p-3">{value.last_name}</td>
                      </tr>
                      
                      <tr>
                        <th className="p-3">Position</th>
                        <td className="p-3">{value.position}</td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Date Of Birth</th>
                         <td className="p-3">
                        {value.date_of_birth
                          ? new Date(value.date_of_birth).toLocaleDateString('en-GB') // "22/09/2024"
                              .replace(/\//g, '-') // Replace slashes with dashes
                          : ''}
                      </td>
                      </tr>
                       <tr>
                        <th className="p-3">Matricule</th>
                        <td className="p-3">{value.matricule}</td>
                      </tr>
                      
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.emp_location?value.emp_location.title: ""}
                        </td>
                      </tr>
               

                      <tr>
                        <th className="p-3">Employee Status</th>
                        <td className="p-3">
                          {value.status}
                        </td>
                      </tr>
                     
                   
                    
                    </table>
                  </div>
                </div>
              </div>
            </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                <div ><h4 style={{paddingTop:"25px", paddingLeft:"25px"}}> Work Time Tracking Details</h4><hr/></div>
                  <div className="table-responsive">
                  <MaterialReactTable columns={columns} data={data} 
                    // enableColumnFilterModes
                    enableColumnOrdering
                    // enableGrouping
                    enablePinning
                   // enableRowActions
                    // enableRowSelection
                    // initialState={{ showColumnFilters: true }}
                 
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};
export default EmployeeWorkTimeDetails;
